import { defaultQuestionTitle } from '@/constant/defaultTitles'
// Legacy
const previewOpenEnded = require('@/assets/images/slide-type-preview/open-ended.svg')
const previewWordCloud = require('@/assets/images/slide-type-preview/word-cloud.svg')
const previewScale = require('@/assets/images/slide-type-preview/scales.svg')
const previewQuestion = require('@/assets/images/slide-type-preview/q&a.svg')
const previewPickAnswer = require('@/assets/images/slide-type-preview/pick-answer.svg')
const previewTypeAnswer = require('@/assets/images/slide-type-preview/type-answer.svg')
const previewHeading = require('@/assets/images/slide-type-preview/heading.svg')
const previewBulletPoints = require('@/assets/images/slide-type-preview/list.svg')
const previewQrcode = require('@/assets/images/slide-type-preview/qr-code.svg')
const previewImage = require('@/assets/images/slide-type-preview/image.svg')
const previewYoutube = require('@/assets/images/slide-type-preview/youtube.svg')
const previewDocument = require('@/assets/images/slide-type-preview/document.svg')
const previewGoogleSlide = require('@/assets/images/slide-type-preview/google-slides.svg')
const previewSpinnerWheel = require('@/assets/images/slide-type-preview/spinner-wheel.svg')
const previewBrainstorm = require('@/assets/images/slide-type-preview/brainstorm.svg')
const previewMatchPairs = require('@/assets/images/slide-type-preview/match-pairs.svg')
// const previewGuessNumber = require('@/assets/images/slide-type-preview/guess-number.svg')
const previewCorrectOrder = require('@/assets/images/slide-type-preview/correct-order.svg')
const previewPoll = require('@/assets/images/slide-type-preview/poll.svg')
const previewContent = require('@/assets/images/slide-type-preview/content.svg')
const previewDiagram = require('@/assets/images/slide-type-preview/diagram.svg')

// French Image
const previewOpenEndedFr = require('@/assets/images/slide-type-preview/fr/open-ended.svg')
const previewWordCloudFr = require('@/assets/images/slide-type-preview/fr/word-cloud.svg')
const previewScaleFr = require('@/assets/images/slide-type-preview/fr/scales.svg')
const previewQuestionFr = require('@/assets/images/slide-type-preview/fr/q&a.svg')
const previewPickAnswerFr = require('@/assets/images/slide-type-preview/fr/pick-answer.svg')
const previewTypeAnswerFr = require('@/assets/images/slide-type-preview/fr/type-answer.svg')
const previewHeadingFr = require('@/assets/images/slide-type-preview/fr/heading.svg')
const previewBulletPointsFr = require('@/assets/images/slide-type-preview/fr/list.svg')
const previewQrcodeFr = require('@/assets/images/slide-type-preview/fr/qr-code.svg')
const previewImageFr = require('@/assets/images/slide-type-preview/fr/image.svg')
const previewYoutubeFr = require('@/assets/images/slide-type-preview/fr/youtube.svg')
// const previewDocumentFr = require('@/assets/images/slide-type-preview/fr/document.svg')
const previewGoogleSlideFr = require('@/assets/images/slide-type-preview/fr/google-slides.svg')
const previewSpinnerWheelFr = require('@/assets/images/slide-type-preview/fr/spinner-wheel.svg')
const previewBrainstormFr = require('@/assets/images/slide-type-preview/fr/brainstorm.svg')
const previewMatchPairsFr = require('@/assets/images/slide-type-preview/fr/match-pairs.svg')
const previewCorrectOrderFr = require('@/assets/images/slide-type-preview/fr/correct-order.svg')
const previewPollFr = require('@/assets/images/slide-type-preview/fr/poll.svg')
const previewContentFr = require('@/assets/images/slide-type-preview/fr/content.svg')
const previewPinOnImage = require('@/assets/images/slide-type-preview/pin-on-image.svg')
const previewRankingSlide = require('@/assets/images/slide-type-preview/rank.svg')
const previewSurvey = require('@/assets/images/slide-type-preview/survey.svg')

// AHA-20221: New Slide Type Previews (visual preview)
const previewVisualBrainstorm = require('@/assets/images/slide-type-preview/visual/brainstorm.webm')
const previewVisualContent = require('@/assets/images/slide-type-preview/visual/content.svg')
const previewVisualCorrectOrder = require('@/assets/images/slide-type-preview/visual/correct-order.webm')
const previewVisualCatagorise = require('@/assets/images/slide-type-preview/visual/categorise.webm')
const previewVisualGoogleSlide = require('@/assets/images/slide-type-preview/visual/google-slides.svg')
const previewVisualHeading = require('@/assets/images/slide-type-preview/visual/heading.svg')
const previewVisualImage = require('@/assets/images/slide-type-preview/visual/image.svg')
const previewVisualList = require('@/assets/images/slide-type-preview/visual/list.svg')
const previewVisualMatchPairs = require('@/assets/images/slide-type-preview/visual/match-pair.webm')
const previewVisualOpenEnded = require('@/assets/images/slide-type-preview/visual/open-ended.webm')
const previewVisualPoll = require('@/assets/images/slide-type-preview/visual/poll.webm')
const previewVisualQuestion = require('@/assets/images/slide-type-preview/visual/q&a.webm')
const previewVisualQrCode = require('@/assets/images/slide-type-preview/visual/qr-code.svg')
const previewVisualScale = require('@/assets/images/slide-type-preview/visual/rating-scale.webm')
const previewVisualShortAnswer = require('@/assets/images/slide-type-preview/visual/short-answer.webm')
const previewVisualSpinnerWheel = require('@/assets/images/slide-type-preview/visual/spinner-wheel.webm')
const previewVisualWordCloud = require('@/assets/images/slide-type-preview/visual/word-cloud.webm')
const previewVisualYoutube = require('@/assets/images/slide-type-preview/visual/youtube.svg')
const previewVisualEmbedSlide = require('@/assets/images/slide-type-preview/visual/embed-slide.svg')
const previewVisualPickAnswerMerged = require('@/assets/images/slide-type-preview/visual/pick-answer-merged.webm')
const previewVisualPinOnImage = require('@/assets/images/slide-type-preview/visual/pin-on-image-o.webm')
const previewVisualRanking = require('@/assets/images/slide-type-preview/visual/ranking.webm')
const previewVisualIdeaBoard = require('@/assets/images/slide-type-preview/visual/idea-board.webm')
const previewVisualSurvey = require('@/assets/images/slide-type-preview/visual/survey.webm')
const previewVisualContentV2 = require('@/assets/images/slide-type-preview/visual/content-v2.webm')

export const VISUAL_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
}

export const SMOKE_TEST_EVENT_ACTIONS = {
  SIGNUP: 'Slide type is under development pop-up > Sign me up',
  REFUSE: 'Slide type is under development pop-up > No thanks',
  OPEN: 'Open Slide type is under development pop-up',
}

export const COMING_SOON_SLIDE_TYPES = {
  IDEA_BOARD: { type: 'ideaBoard', featureFlag: 'AHA-39912-idea-board-slide-type' },
  PIN_ON_IMAGE: { type: 'pinOnImage', featureFlag: 'AHA-40699-pin-on-image-slide-type' },
  RANKING: { type: 'ranking', featureFlag: 'release-AHA-40791-ranking-slide-type' },
  DIAGRAM: { type: 'diagram', featureFlag: 'AHA-42445-diagram-slide' },
}

// Constants for commonly duplicated strings
const HACKATHON_SLIDE_TYPE = 'hackathon-slide'
const PICK_ANSWER_ICON = 'pick-answer'
const PICK_ANSWER_WHITE_ICON = 'pick-answer-w'
const PICK_ANSWER_PREVIEW = 'pickAnswer'
const QUIZ_LABEL = 'Quiz'
const PICK_ANSWER_TYPE = 'pickAnswer'
const QUIZ_GAME_DESC = 'Ask quiz questions, or play games, and let your participants compete for victory!'
const TASKS_ICON = 'fas fa-tasks'
const TUTORIAL_VIDEO_URL = 'https://www.youtube.com/embed/BfOV2Rd9soY'

export const SLIDES_TYPE_LIMIT_FIVE = [PICK_ANSWER_PREVIEW]
export const SLIDE_TYPE_LIMIT_TWO = ['imageChoice', 'scale', 'wordCloud', 'openEnded']
const slideTypes = [
  {
    title: 'Hackathon 2025',
    sectionLabel: 'Hackathon',
    sectionIcon: 'mti-check',
    sectionKey: 'hackathon',
    desc: QUIZ_GAME_DESC,
    slideTypes: [
      {
        name: 'True or False',
        icon: TASKS_ICON,
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'true-or-false',
        desc: 'Swipe through statements and pick True or False',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        canvasUrl: 'https://exotic-parakeet-unlikely.ngrok-free.app/swipee/demo/present',
        editorUrl: 'https://exotic-parakeet-unlikely.ngrok-free.app/swipee/demo/edit',
        audienceUrl: 'https://exotic-parakeet-unlikely.ngrok-free.app/swipee/audience',
      },
      {
        name: 'Quiz Hackathon',
        icon: TASKS_ICON,
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'hackathon',
        desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
        canvasUrl: 'http://172.20.10.4:3002/present',
        editorUrl: 'http://172.20.10.4:3002/edit',
        audienceUrl: 'http://172.20.10.4:3002/join',
      },
      {
        name: 'A Deck Of Cards',
        icon: TASKS_ICON,
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'hackathon-deck-of-cards',
        desc: 'Shuffle a deck of cards and let participants pick one card.',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
        canvasUrl: 'https://192.168.1.91/present',
        editorUrl: 'https://192.168.1.91/edit',
        audienceUrl: 'https://192.168.1.91/audience',
      },
      {
        name: 'Countdown Timer',
        icon: 'fas fa-hourglass-half',
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'countdownTimer',
        desc: 'Display a customizable countdown timer with title/message for sessions and activities.',
        label: 'Timer',
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
        canvasUrl: 'https://huong-ahaslides.ngrok.app/present',
        editorUrl: 'https://huong-ahaslides.ngrok.app/edit',
        audienceUrl: 'https://huong-ahaslides.ngrok.app/join',
      },
      {
        name: 'Walking Question',
        icon: TASKS_ICON,
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'hackathon-walking-question',
        desc: 'Participants submit a question and answer it in a round-robin style.',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
        canvasUrl: 'https://don-ahaslides.ngrok.app/presenter',
        editorUrl: 'https://don-ahaslides.ngrok.app/editor',
        audienceUrl: 'https://don-ahaslides.ngrok.app/audience',
      },
      {
        name: 'Random Assignments',
        icon: TASKS_ICON,
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'randomAssignments',
        desc: 'Pick your box and open it to reveal a surprise.',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
        canvasUrl: 'http://192.168.1.36:5173/present',
        editorUrl: 'http://192.168.1.36:5173/edit',
        audienceUrl: 'http://192.168.1.36:5173/join',
      },
      {
        name: 'Draw',
        icon: TASKS_ICON,
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'hackathon-draw',
        desc: 'Participants must draw on the screen to find the final answer.',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
        canvasUrl: 'https://duncan.ngrok.app/present',
        editorUrl: 'https://duncan.ngrok.app/edit',
        audienceUrl: 'https://duncan.ngrok.app/audience',
      },
      {
        name: 'Sneak a peek',
        icon: TASKS_ICON,
        type: HACKATHON_SLIDE_TYPE,
        slideType: 'sneak-a-peek',
        desc: 'Find answers based on provided image.',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
        canvasUrl: 'http://192.168.1.72:3000/present',
        editorUrl: 'http://192.168.1.72:3000/edit',
        audienceUrl: 'http://192.168.1.72:3000/audience',
      },
    ],
  },
  {
    title: 'Quiz and games',
    sectionLabel: QUIZ_LABEL,
    sectionIcon: 'mti-check',
    sectionKey: 'quiz',
    desc: QUIZ_GAME_DESC,
    slideTypes: [
      {
        name: 'Pick Answer',
        icon: TASKS_ICON,
        type: PICK_ANSWER_TYPE,
        slideType: 'imageChoice',
        desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
        label: QUIZ_LABEL,
        ahaIcon: PICK_ANSWER_ICON,
        ahaIconWhite: PICK_ANSWER_WHITE_ICON,
        ahaIconTest: 'pick-answer-v3-dark',
        ahaIconTestWhite: 'pick-answer-v3-light',
        preview: PICK_ANSWER_PREVIEW,
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        previewUrlVisual: previewVisualPickAnswerMerged,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: TUTORIAL_VIDEO_URL,
      },
      {
        name: 'Short Answer',
        icon: 'fas fa-keyboard',
        type: PICK_ANSWER_TYPE,
        slideType: 'typeAnswer',
        desc: 'Ask a quiz question and write in the answer(s) that you will accept. Participants try to write the correct answer and will score points if it matches your accepted answer(s).',
        label: QUIZ_LABEL,
        ahaIcon: 'mti-type-answer',
        ahaIconWhite: 'mti-type-answer-w',
        ahaIconTest: 'short-answer-v3-dark',
        ahaIconTestWhite: 'short-answer-v3-light',
        preview: 'typeAnswer',
        previewUrl: previewTypeAnswer,
        previewUrlFr: previewTypeAnswerFr,
        previewUrlVisual: previewVisualShortAnswer,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/LOTd2BLgPgw',
      },
      {
        name: 'Spinner Wheel',
        icon: 'fas fa-keyboard',
        type: 'spinnerWheel',
        desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
        label: '',
        ahaIcon: 'spinner-wheel',
        ahaIconWhite: 'spinner-wheel-w',
        ahaIconTest: 'spinner-wheel-v3-dark',
        ahaIconTestWhite: 'spinner-wheel-v3-light',
        preview: 'spinnerWheel',
        previewUrl: previewSpinnerWheel,
        previewUrlFr: previewSpinnerWheelFr,
        previewUrlVisual: previewVisualSpinnerWheel,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/-PaqZrxnDOw',
      },
      {
        name: 'Match Pairs',
        type: PICK_ANSWER_TYPE,
        slideType: 'matchPairs',
        desc: 'Pose a question and provide prompts and answers. Participants try to match each prompt to its accompanying answer.',
        label: QUIZ_LABEL,
        ahaIcon: 'match-pairs',
        ahaIconWhite: 'match-pairs-w',
        ahaIconTest: 'match-pairs-v3-dark',
        ahaIconTestWhite: 'match-pairs-v3-light',
        preview: 'matchPairs',
        previewUrl: previewMatchPairs,
        previewUrlFr: previewMatchPairsFr,
        previewUrlVisual: previewVisualMatchPairs,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/0qvPBJcxvYo',
      },
      {
        name: 'Correct Order',
        type: PICK_ANSWER_TYPE,
        slideType: 'correctOrder',
        desc: 'Provide up to 10 mixed-up options and let participants order them.',
        label: QUIZ_LABEL,
        ahaIcon: 'correct-order',
        ahaIconWhite: 'correct-order-w',
        ahaIconTest: 'correct-order-v3-dark',
        ahaIconTestWhite: 'correct-order-v3-light',
        preview: 'correctorder',
        previewUrl: previewCorrectOrder,
        previewUrlFr: previewCorrectOrderFr,
        previewUrlVisual: previewVisualCorrectOrder,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/wNCbN-Q7UY8',
      },
      {
        name: 'Categorise',
        type: PICK_ANSWER_TYPE,
        slideType: 'categorise',
        label: QUIZ_LABEL,
        ahaIcon: 'categorise',
        ahaIconWhite: 'categorise-white',
        ahaIconTest: 'categorise-v3-dark',
        ahaIconTestWhite: 'categorise-v3-light',
        preview: 'correctorder',
        previewUrlVisual: previewVisualCatagorise,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/WVZ6a8vQF5A',
        videoTutorialUrlFr: 'https://www.youtube.com/embed/Qoi2A5UYsgg',
      },
      {
        name: 'Leaderboard',
        type: 'leaderboard',
        ahaIconTest: 'leaderboard-v3-dark',
        ahaIconTestWhite: 'leaderboard-v3-light',
        noType: true,
      },
    ],
  },
  {
    title: 'Opinion and Q&A',
    sectionLabel: 'Collect opinions - Q&A',
    sectionIcon: 'mti-comment',
    sectionKey: 'poll',
    desc: 'Collect opinions from your audience in a range of formats, or address their questions through a Q&A slide!',
    slideTypes: [
      {
        name: 'Poll',
        icon: 'fas fa-signal',
        type: 'imageChoice',
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        ahaIconTest: 'poll-v3-dark',
        ahaIconTestWhite: 'poll-v3-light',
        preview: 'poll',
        previewUrl: previewPoll,
        previewUrlFr: previewPollFr,
        previewUrlVisual: previewVisualPoll,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/cVfaZNj-T-c',
      },
      {
        name: 'Open Ended',
        icon: 'fas fa-comment-dots',
        type: 'openEnded',
        desc: 'Pose a question and let participants freely write their responses. Set fields for participants´ names, teams, emails or avatars.',
        ahaIcon: 'open-ended',
        ahaIconWhite: 'open-ended-w',
        ahaIconTest: 'open-ended-v3-dark',
        ahaIconTestWhite: 'open-ended-v3-light',
        preview: 'openEnded',
        previewUrl: previewOpenEnded,
        previewUrlFr: previewOpenEndedFr,
        previewUrlVisual: previewVisualOpenEnded,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/O7o7j4BZDDc',
      },
      {
        name: 'Word Cloud',
        type: 'wordCloud',
        icon: 'fas fa-cloud',
        desc: 'Pose a question and let participants write 1 or 2-word answers. The more popular an answer is, the larger it will appear on screen.',
        ahaIcon: 'word-cloud',
        ahaIconWhite: 'word-cloud-w',
        ahaIconTest: 'word-cloud-v3-dark',
        ahaIconTestWhite: 'word-cloud-v3-light',
        preview: 'wordCloud',
        previewUrl: previewWordCloud,
        previewUrlFr: previewWordCloudFr,
        previewUrlVisual: previewVisualWordCloud,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/fAIi4n1V8yk',
      },

      {
        name: 'Brainstorm',
        type: 'ideas',
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Provide a topic and let the audience submit their ideas. Each participant votes for their favourite ideas and the results are ranked by popularity.',
        ahaIcon: 'brainstorm',
        ahaIconWhite: 'brainstorm-white',
        ahaIconTestWhite: 'brainstorm-v3-light',
        ahaIconTest: 'brainstorm-v3-dark',
        preview: 'brainstorm',
        previewUrl: previewBrainstorm,
        previewUrlFr: previewBrainstormFr,
        previewUrlVisual: previewVisualBrainstorm,
        visualType: VISUAL_TYPE.VIDEO,
        isForPairPlan: true,
        videoTutorialUrl: 'https://www.youtube.com/embed/JaxWbKImUcQ',
      },

      {
        name: 'Idea Board',
        type: 'ideaBoard',
        icon: 'fas fa-comment',
        isNew: true,
        iconInside: true,
        desc: 'Participants write and vote on questions for you to answer. All questions are displayed on screen for you to address one by one. Pin questions to save them or mark as answered to remove them.',
        ahaIcon: 'idea-board-dark',
        ahaIconWhite: 'idea-board-light',
        ahaIconTest: 'idea-board-v3-dark',
        ahaIconTestWhite: 'idea-board-v3-light',
        preview: 'question',
        previewUrlVisual: previewVisualIdeaBoard,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/O691TLPtsto',
        plugin: true,
        defaultSlideTitle: defaultQuestionTitle,
        setting: {
          enableQuestionTitle: true,
          enableQuestionDescription: true,
          enableStopSubmitssionSetting: true,
          enableHideResultSetting: true,
          enableFilteringProfanitySetting: true,
          enableQuestionImage: true,
          enableImageSubmissionSetting: true,
          enableShowVotingResultsOnAudienceVisible: true,
          enableTimeLimit: true,
          enableVotesPerParticipantSetting: false,
          enableAdditionalFieldsSetting: true,
          enableVoteCount: true,
          enableLabelOtherSetting: true,
          enableMultipleSubmission: true,
        },
      },
      {
        name: 'Pin on Image',
        type: 'pinOnImage',
        icon: 'fas fa-comment',
        isNew: true,
        iconInside: true,
        desc: 'Participants drop pins on your image to answer the question.',
        ahaIcon: 'pin-on-image',
        ahaIconWhite: 'pin-on-image-w',
        ahaIconTest: 'pin-on-image-v3-dark',
        ahaIconTestWhite: 'pin-on-image-v3-light',
        preview: 'pinOnImage',
        previewUrl: previewPinOnImage,
        previewUrlFr: previewPinOnImage,
        previewUrlVisual: previewVisualPinOnImage,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/Uo2Vv4Gyh1k',
        plugin: true,
        defaultSlideTitle: defaultQuestionTitle,
        setting: {
          enableQuestionTitle: true,
          enableQuestionDescription: true,
          enableStopSubmitssionSetting: true,
          enableHideResultSetting: true,
          enableFilteringProfanitySetting: false,
          enableQuestionImage: false,
          enableImageSubmissionSetting: false,
          enableShowVotingResultsOnAudienceVisible: false,
          enableTimeLimit: true,
          enableVotesPerParticipantSetting: false,
          enableAdditionalFieldsSetting: false,
          enableVoteCount: true,
          enableLabelOtherSetting: false,
          enableMultipleSubmission: false,
        },
      },
      {
        name: 'Ranking',
        type: 'ranking',
        icon: 'fas fa-comment',
        isNew: true,
        iconInside: true,
        desc: 'Ask your audience to rank items in order of preference. The results are displayed in a bar chart showing the overall ranking.',
        ahaIcon: 'rank-slide-type',
        ahaIconWhite: 'rank-slide-type',
        ahaIconTest: 'ranking-v3-dark',
        ahaIconTestWhite: 'ranking-v3-light',
        preview: 'ranking',
        previewUrl: previewRankingSlide,
        previewUrlFr: previewRankingSlide,
        previewUrlVisual: previewVisualRanking,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/50-cMvcMni8',
        plugin: true,
        defaultSlideTitle: defaultQuestionTitle,
        setting: {
          enableQuestionTitle: true,
          enableQuestionDescription: true,
          enableTimeLimit: true,
          enableStopSubmitssionSetting: true,
          enableHideResultSetting: true,
          enableQuestionImage: true,
          enableVoteCount: true,
          enableLabelOtherSetting: false,
          enableMultipleSubmission: false,
        },
      },
      {
        name: 'Rating Scale',
        type: 'scale',
        icon: 'fas fa-sliders-h',
        desc: 'Pose a question, write statements and let your participants rate each statement on a scale. Results are shown in a colour-coded graph that shows the popularity of each statement.',
        ahaIcon: 'scales',
        ahaIconWhite: 'scales-w',
        ahaIconTest: 'rating-scale-v3-dark',
        ahaIconTestWhite: 'rating-scale-v3-light',
        preview: 'scale',
        previewUrl: previewScale,
        previewUrlFr: previewScaleFr,
        visualType: VISUAL_TYPE.VIDEO,
        previewUrlVisual: previewVisualScale,
        videoTutorialUrl: 'https://www.youtube.com/embed/1Iamxm2iJeM',
      },
      {
        name: 'Q&A',
        type: 'question',
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Participants write and vote on questions for you to answer. All questions are displayed on screen for you to address one by one. Pin questions to save them or mark as answered to remove them.',
        ahaIcon: 'qa',
        ahaIconWhite: 'q&a-w',
        ahaIconTest: 'qna-v3-dark',
        ahaIconTestWhite: 'qna-v3-light',
        preview: 'question',
        previewUrl: previewQuestion,
        previewUrlFr: previewQuestionFr,
        previewUrlVisual: previewVisualQuestion,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/Z1kCoy9i6N0',
      },
      // Survey is registered directly here (not via the embed-app manifest) so
      // it appears under "Unscored" next to Q&A instead of an auto-generated
      // "Custom" section. Per Dave Bui's request 2026-05-22. The iframe URL is
      // still built from `${config.slidePluginUrl}/survey/{canvas|settings}/{slideId}`
      // by SlidePluginIframeEmbed.vue + SlidePluginIframeConfig.vue, which is
      // exactly the URL pattern the aha-survey plugin host serves.
      //
      // Icons shipped in stpancras-storybook-app PR #27 as the v3 pair
      // (survey-v3-light = #4A4A4A on white bg, survey-v3-dark = #FDFDFD
      // on dark bg) at 24x24 — matches the diagram-v3-* convention so the
      // icon renders at the same size as Idea Board / Pin on Image /
      // Brainstorm / Diagram. Requires storybook-app >= 2.3.13.
      {
        name: 'Survey',
        type: 'survey',
        icon: 'fas fa-list-alt',
        iconInside: true,
        isNew: true,
        desc: 'Run a multi-question survey on the slide. Audience taps in on their device to respond; collect answers asynchronously and review them in the survey dashboard.',
        ahaIcon: 'survey-v3-light',
        ahaIconWhite: 'survey-v3-dark',
        ahaIconTest: 'survey-v3-dark',
        ahaIconTestWhite: 'survey-v3-light',
        preview: 'survey',
        previewUrl: previewSurvey,
        previewUrlFr: previewSurvey,
        previewUrlVisual: previewVisualSurvey,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/PNq5cczsDAE',
        plugin: true,
        setting: {
          enableQuestionTitle: true,
          enableQuestionDescription: false,
          enableTimeLimit: false,
          enableStopSubmitssionSetting: false,
          enableHideResultSetting: false,
          enableQuestionImage: false,
          enableVoteCount: false,
          enableLabelOtherSetting: false,
          enableMultipleSubmission: false,
          enableFullScreen: false,
        },
      },
      ...(process.env.VUE_APP_SLIDE_PLUGIN_SAMPLE ? [{
        name: 'Sample Slide',
        type: 'sample-slide',
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Sample plugin slide to demonstrate API.',
        ahaIcon: 'qa',
        ahaIconWhite: 'q&a-w',
        ahaIconTest: 'qna-v3-dark',
        ahaIconTestWhite: 'qna-v3-light',
        preview: 'question',
        previewUrl: previewQuestion,
        previewUrlFr: previewQuestionFr,
        previewUrlVisual: previewVisualQuestion,
        visualType: VISUAL_TYPE.VIDEO,
        videoTutorialUrl: 'https://www.youtube.com/embed/Z1kCoy9i6N0',
        plugin: true,
        defaultSlideTitle: defaultQuestionTitle,
        setting: {
          enableQuestionTitle: true,
          enableQuestionDescription: true,
          enableStopSubmitssionSetting: true,
          enableHideResultSetting: true,
          enableFilteringProfanitySetting: true,
          enableQuestionImage: true,
          enableImageSubmissionSetting: true,
          enableShowVotingResultsOnAudienceVisible: true,
          enableTimeLimit: true,
          enableVotesPerParticipantSetting: true,
          enableAdditionalFieldsSetting: true,
          enableVoteCount: true,
          enableLabelOtherSetting: true,
          enableMultipleSubmission: true,
          enableAudienceJoinPresentation: false,
          enableGameLobby: false,
        },
      }] : []),
    ],
  },
  {
    title: 'Content slide',
    sectionLabel: 'Content',
    sectionIcon: 'mti-content',
    sectionKey: 'content',
    desc: 'Add text content, image, video... to your presentation',
    slideTypes: [
      {
        name: 'Content',
        type: 'freestyle',
        desc: 'Add and edit text, images and bullet points.',
        ahaIcon: 'content',
        ahaIconWhite: 'content-w',
        ahaIconTest: 'content-v3-dark',
        ahaIconTestWhite: 'content-v3-light',
        preview: 'content',
        previewUrl: previewContent,
        previewUrlFr: previewContentFr,
        previewUrlVisual: previewVisualContent,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Heading',
        subheading: 'Subheading',
        type: 'textSlide',
        desc: 'Write a heading and an optional subheading. You can use this for introducing a question or quiz slide. This slide type also works great as an opening to a new section of the presentation.',
        ahaIcon: 'heading',
        ahaIconWhite: 'heading-w',
        ahaIconTest: 'heading-v3-dark',
        ahaIconTestWhite: 'heading-v3-light',
        preview: 'heading',
        previewUrl: previewHeading,
        previewUrlFr: previewHeadingFr,
        previewUrlVisual: previewVisualHeading,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'List',
        type: 'bulletPoints',
        html: '<i class="fas fa-list bulletPoints-icon"></i>',
        desc: 'Write a bullet point list. You can also add a heading and a subheading.',
        ahaIcon: 'list',
        ahaIconWhite: 'list-w',
        ahaIconTest: 'list-v3-dark',
        ahaIconTestWhite: 'list-v3-light',
        preview: 'bulletPoints',
        previewUrl: previewBulletPoints,
        previewUrlFr: previewBulletPointsFr,
        previewUrlVisual: previewVisualList,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Diagram',
        type: 'diagram',
        isNew: true,
        iconInside: true,
        desc: 'Visualise structured information — flow diagrams, hierarchies, charts, word clouds, comparisons, timelines.',
        // Icons from Design System V3, shipped in stpancras-storybook-app
        // alongside the v3 set added in storybook PR #12. Naming follows the
        // v3 convention: `-v3-light` = #4A4A4A stroke for light bg,
        // `-v3-dark` = #FDFDFD stroke for dark bg.
        ahaIcon: 'diagram-v3-light',
        ahaIconWhite: 'diagram-v3-dark',
        ahaIconTest: 'diagram-v3-dark',
        ahaIconTestWhite: 'diagram-v3-light',
        preview: 'diagram',
        previewUrl: previewDiagram,
        previewUrlFr: previewDiagram,
        previewUrlVisual: previewDiagram,
        visualType: VISUAL_TYPE.IMAGE,
        plugin: true,
        // RightColumnCommonSlidesConfig + sibling components dereference
        // `slideActiveConfig.setting.<flag>` without optional chaining, so a
        // missing `setting` object throws and blanks the right panel.
        // Diagram owns its own title / content UI inside the iframe and has
        // no audience interaction, so every flag is off. enableFullScreen lets
        // the canvas use the full slide area like the freestyle content slide.
        setting: {
          enableQuestionTitle: false,
          enableQuestionDescription: false,
          enableTimeLimit: false,
          enableStopSubmitssionSetting: false,
          enableHideResultSetting: false,
          enableQuestionImage: false,
          enableImageSubmissionSetting: false,
          enableFilteringProfanitySetting: false,
          enableShowVotingResultsOnAudienceVisible: false,
          enableVotesPerParticipantSetting: false,
          enableAdditionalFieldsSetting: false,
          enableVoteCount: false,
          enableLabelOtherSetting: false,
          enableMultipleSubmission: false,
          enableFullScreen: true,
        },
      },
      // Content V2 (AHA-42560) — successor to the freestyle "Content" slide.
      // Registered directly here (not via the embed-app manifest) so it
      // appears under the Content section next to the legacy "Content"
      // entry rather than being auto-bucketed into "Custom". Mirrors PR
      // #4349 which did the same for Survey.
      //
      // The iframe URL is `${config.slidePluginUrl}/content-v2/{canvas|settings}/{slideId}`
      // built by SlidePluginIframeEmbed.vue + SlidePluginIframeConfig.vue,
      // which is exactly the URL pattern the Content V2 plugin host serves
      // (content-v2/frontend/src/router.tsx).
      //
      {
        name: 'Content v2',
        type: 'content-v2',
        isNew: true,
        iconInside: true,
        desc: 'Compose a slide with text, images, shapes, and smart layouts on a free-form surface. The next-generation content slide — drag, snap, and arrange blocks the way you want.',
        // `system-smart-content-{light,dark}` baked-color pair (storybook 2.3.15).
        // The slide-type picker renders icons with maintainColor=true, so each
        // theme mode needs its own baked fill — same as `content-v3-*`. `-light`
        // (#4A4A4A) is the dark glyph for light backgrounds; `-dark` (#FDFDFD)
        // is the light glyph for dark backgrounds.
        ahaIcon: 'system-smart-content-light',
        ahaIconWhite: 'system-smart-content-dark',
        ahaIconTest: 'system-smart-content-dark',
        ahaIconTestWhite: 'system-smart-content-light',
        // Unique preview key so the Content V2 video does not collide with the
        // legacy "Content" slide in the slideTypePreview preload map.
        preview: 'content-v2',
        previewUrl: previewContent,
        previewUrlFr: previewContentFr,
        previewUrlVisual: previewVisualContentV2,
        visualType: VISUAL_TYPE.VIDEO,
        plugin: true,
        // Full-canvas plugin — Canvas owns its own block editor inside the
        // iframe and has no audience interaction, so every interaction
        // flag is off. enableFullScreen mirrors Diagram so the canvas
        // uses the full slide area like the freestyle content slide.
        setting: {
          enableQuestionTitle: false,
          enableQuestionDescription: false,
          enableTimeLimit: false,
          enableStopSubmitssionSetting: false,
          enableHideResultSetting: false,
          enableQuestionImage: false,
          enableImageSubmissionSetting: false,
          enableFilteringProfanitySetting: false,
          enableShowVotingResultsOnAudienceVisible: false,
          enableVotesPerParticipantSetting: false,
          enableAdditionalFieldsSetting: false,
          enableVoteCount: false,
          enableLabelOtherSetting: false,
          enableMultipleSubmission: false,
          enableFullScreen: true,
          // Opt this built-in plugin slide into next-slide iframe preload:
          // PreloadIframeHost warms the canvas URL one slide ahead so first
          // paint on navigation is faster. Default is off for every other
          // slide type — see DEFAULT_CUSTOM_SLIDE_SETTING in slide-plugin.getters.
          enableIframePreload: true,
        },
      },
      {
        name: 'Image',
        type: VISUAL_TYPE.IMAGE,
        icon: 'far fa-image',
        desc: 'Display an image either centrally on the slide or full-screen. Use your own images or choose ones from our library.',
        ahaIcon: 'type-image',
        ahaIconWhite: 'image-w',
        ahaIconTest: 'image-v3-dark',
        ahaIconTestWhite: 'image-v3-light',
        preview: VISUAL_TYPE.IMAGE,
        previewUrl: previewImage,
        previewUrlFr: previewImageFr,
        previewUrlVisual: previewVisualImage,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'QR Code',
        type: 'qrcode',
        icon: 'fas fa-qrcode',
        desc: 'Display the unique QR code for your presentation. Participants can scan this on their devices to join your quiz. Tip: You can also show this QR code on any other slide types by clicking the top of your slide.',
        ahaIcon: 'qr-code',
        ahaIconWhite: 'qr-code-w',
        ahaIconTest: 'qrcode-v3-dark',
        ahaIconTestWhite: 'qrcode-v3-light',
        preview: 'qrcode',
        previewUrl: previewQrcode,
        previewUrlFr: previewQrcodeFr,
        previewUrlVisual: previewVisualQrCode,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'YouTube',
        type: 'youtube',
        icon: 'fab fa-youtube',
        desc: 'Embed a YouTube video. Simply copy and paste the YouTube URL into the slide.',
        ahaIcon: 'youtube',
        ahaIconWhite: 'youtube-w',
        ahaIconTest: 'youtube-v3-dark',
        ahaIconTestWhite: 'youtube-v3-light',
        preview: 'youtube',
        previewUrl: previewYoutube,
        previewUrlFr: previewYoutubeFr,
        previewUrlVisual: previewVisualYoutube,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Embed',
        type: 'embed',
        desc: 'Embed a website. Simply copy and paste the website URL into the slide.',
        ahaIcon: 'embed',
        ahaIconWhite: 'embed-dark',
        ahaIconTest: 'embed-v3-dark',
        ahaIconTestWhite: 'embed-v3-light',
        preview: 'embed',
        previewUrl: previewVisualEmbedSlide,
        previewUrlFr: previewVisualEmbedSlide,
        previewUrlVisual: previewVisualEmbedSlide,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Google Slides',
        type: 'googleSlides',
        icon: 'fab fa-google',
        desc: 'Embed a Google Slides presentation. The entire slideshow will be displayed within this one slide.',
        ahaIcon: 'google-slides-brand-b',
        ahaIconWhite: 'google-slides-brand-w',
        ahaIconTest: 'google-slides-v3-dark',
        ahaIconTestWhite: 'google-slides-v3-light',
        preview: 'googleSlides',
        previewUrl: previewGoogleSlide,
        previewUrlFr: previewGoogleSlideFr,
        previewUrlVisual: previewVisualGoogleSlide,
        visualType: VISUAL_TYPE.IMAGE,
      },
      {
        name: 'Document',
        type: 'document',
        icon: 'fas fa-file-import',
        desc: 'Import a PowerPoint or PDF document into this presentation.',
        ahaIcon: 'document',
        ahaIconWhite: 'document-w',
        ahaIconTestWhite: 'document-v3-light',
        ahaIconTest: 'document-v3-dark',
        preview: 'document',
        previewUrl: previewDocument,
        previewUrlFr: previewDocument,
        visualType: VISUAL_TYPE.IMAGE,
        hidden: true,
      },
    ],
  },
]

const EXCLUDED_SLIDE_TYPES_FOR_IMPROVING_SLIDE_CONTENT = ['qrCode', 'youtube', 'googleSlides']

const INTERACTIVE_SLIDE_NAMES = ['Pick Answer', 'Short Answer', 'Match Pairs', 'Correct Order', 'Categorise', 'Poll']
const AI_CHAT_INTERACTIVE_SLIDE_NAMES = ['Pick Answer', 'Short Answer', 'Match Pairs', 'Correct Order']

const extensibleSlideTypes = [
  'hackathon-slide',
  'embed',
]

const allSlideTypes = slideTypes.reduce((acc, slideType) => {
  acc.push(...slideType.slideTypes)
  return acc
}, [])

const SLIDE_TYPES_MAP = {
  FREE_STYLE: 'freestyle',
  MULTIPLE_CHOICE: 'multipleChoice',
  IMAGE_CHOICE: 'imageChoice',
  OPEN_ENDED: 'openEnded',
  WORD_CLOUD: 'wordCloud',
  SCALE: 'scale',
  QUESTION: 'question',
  PICK_ANSWER: 'pickAnswer',
  LEADERBOARD: 'leaderboard',
  TEXT_SLIDE: 'textSlide',
  BULLET_POINTS: 'bulletPoints',
  QR_CODE: 'qrCode',
  IMAGE: 'image',
  YOUTUBE: 'youtube',
  GOOGLE_SLIDES: 'googleSlides',
  DOCUMENT: 'document',
  SPINNER_WHEEL: 'spinnerWheel',
  IDEAS: 'ideas',
  TYPE_ANSWER: 'typeAnswer',
  CORRECT_ORDER: 'correctOrder',
  MATCH_PAIRS: 'matchPairs',
  CATEGORISE: 'categorise',
  EMBED: 'embed',
  IDEA_BOARD: 'ideaBoard',
  PIN_ON_IMAGE: 'pinOnImage',
  RANKING: 'ranking',
  DIAGRAM: 'diagram',
  SURVEY: 'survey',
  CONTENT_V2: 'content-v2',
}

export {
  slideTypes, EXCLUDED_SLIDE_TYPES_FOR_IMPROVING_SLIDE_CONTENT, INTERACTIVE_SLIDE_NAMES,
  AI_CHAT_INTERACTIVE_SLIDE_NAMES, extensibleSlideTypes, allSlideTypes,
  SLIDE_TYPES_MAP,
}

// export default slideTypes
